<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="warp" :style="{height:fixedHeight+'px'}">
			<!-- 未审批采购单搜索 -->
			<div v-if="tabs == 1" class="title">
				<!-- 未审批申请单 -->
				<div class="comView">
					<el-input v-model="serchValue1" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" clearable size="small"/>
					<el-button type="warning" style="margin-left: 10px;" @click="getListData" size="small">搜索</el-button>
				</div>
				<div class="comView">
					<div class="m-r-10">门店申请日期</div>
					<el-date-picker v-model="dateValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="titleDate" @change="handleChange" :default-time="['00:00:00','23:59:59']" value-format="timestamp" size="small"/>
				</div>
				<div class="comView">
					<div class="m-r-10">门店</div>
					<el-select v-model="shopValue" placeholder="请选择" class="titleSelect" @change="handleChange" size="small">
						<el-option v-for="item in shopOptions" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>
				<div class="comView">
					<div class="m-r-10">门店确认</div>
					<el-select v-model="isShopConfirm" placeholder="请选择" class="titleSelect" @change="handleChange" size="small">
						<el-option v-for="item in isShopOptions" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>
				<div style="margin-left: 10px;">
					<!-- <el-button type="primary" class="addClick">添加新品</el-button> -->
					<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				</div>
				<!-- 已审批采购单 -->
			</div>
			<!-- 已审批采购单搜索 -->
			<div v-if="tabs == 2" class="title">
				<!-- 未审批申请单 -->
				<div class="comView">
					<el-input v-model="serchValue2" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" size="small" />
					<el-button type="warning" style="margin-left: 10px;" @click="getListData" size="small">搜索</el-button>
				</div>
				<div class="comView">
					<div class="m-r-10 m-l-10">门店申请日期</div>
					<el-date-picker v-model="dateValue2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="titleDate" @change="handleChange" :default-time="['00:00:00','23:59:59']" value-format="timestamp" size="small" />
				</div>
				<div class="comView">
					<div class="m-r-10">审批日期</div>
					<el-date-picker v-model="dateValue4" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="titleDate" @change="handleChange" :default-time="['00:00:00','23:59:59']" value-format="timestamp" size="small" />
				</div>
				<div class="comView">
					<div class="m-r-10 m-l-10">门店</div>
					<el-select v-model="shopValue2" placeholder="请选择" class="titleSelect" @change="handleChange" size="small">
						<el-option v-for="item in shopOptions" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>
				<div class="comView">
					<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				</div>
				<div class="comView">
					<div style="text-align:right;">
						<el-button type="warning" class="addClick" @click="handleAddOrderClick" size="small">生成采购单</el-button>
					</div>
				</div>
			</div>
			<!-- 审批驳回 -->
			<div v-if="tabs == 3" class="title">
				<!-- 未审批申请单 -->
				<div class="comView">
					<el-input v-model="serchValue3" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" size="small" />
					<el-button type="warning" style="margin-left: 10px;" @click="getListData" size="small">搜索</el-button>
				</div>
				<div class="comView">
					<div class="m-r-10">门店申请日期</div>
					<el-date-picker v-model="dateValue3" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="titleDate" @change="handleChange" :default-time="['00:00:00','23:59:59']" value-format="timestamp" size="small" />
				</div>
				<div class="comView">
					<div class="m-r-10">驳回日期</div>
					<el-date-picker v-model="dateValue4" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="titleDate" @change="handleChange" :default-time="['00:00:00','23:59:59']" value-format="timestamp" size="small" />
				</div>
				<div class="comView">
					<div class="m-r-10">门店</div>
					<el-select v-model="shopValue3" placeholder="请选择" class="titleSelect" @change="handleChange" size="small">
						<el-option v-for="item in shopOptions" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>
				<div class="comView">
					<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				</div>
			</div>
			<!-- tab切换 -->
			<!-- <div class="tabs">
				<el-badge :value="checkCount" class="item m-r-40">
					<el-button size="small" :class="tabs == 1?'active':'noactive'" @click="handleTabClick(1)">未审批申请单</el-button>
				</el-badge>
				<el-button size="small" :class="tabs == 2?'active m-r-40':'noactive m-r-40'" @click="handleTabClick(2)">已审批申请单</el-button>
				<el-button size="small" :class="tabs == 3?'active m-r-40':'noactive m-r-40'" @click="handleTabClick(3)" style="margin-left: 0;">审批驳回</el-button>
			</div> -->
			<div class="tabLine">
				<el-badge :value="checkCount">
					<div class="tabItem" :class="[tabs==1?'active':'']" @click="handleTabClick(1)">未审批申请单</div>
				</el-badge>
				<div class="tabItem" :class="[tabs==2?'active':'']" @click="handleTabClick(2)">已审批申请单</div>
				<div class="tabItem" :class="[tabs==3?'active':'']" @click="handleTabClick(3)">审批驳回</div>
			</div>

			<!-- 表格 -->
			<div class="tableWarp">
				<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
					<el-table-column :key="1" type="selection" />
					<el-table-column :key="2" prop="procureRequestNo" label="审批批次号" width="200">
						<template slot-scope="scope">
							<div>
								<span>{{scope.row.procureRequestNo}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="3"  label="门店申请日期">
						<template slot-scope="scope">
							<span v-if="scope.row.createOperationInfo">{{scope.row.createOperationInfo.operationTime}}</span>
						</template>
					</el-table-column>
					<el-table-column v-if="tabs == 3" :key="4" label="驳回日期">
						<template slot-scope="scope">
							<span v-if="scope.row.checkInfo">{{scope.row.checkInfo.checkUserInfo.operationTime}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="6" prop="shopInfo.shopName" label="申请门店" show-overflow-tooltip>
						<template slot-scope="scope">
					<span>{{scope.row.shopInfo.shopName}}</span>
				</template>
					</el-table-column>
					<el-table-column :key="5" label="申请人" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.createOperationInfo" >{{scope.row.createOperationInfo.userName}}</span>
						</template>
					</el-table-column>
					<el-table-column v-if="tabs == 1" :key="7" prop="isShopConfirm" :formatter="shopConfirmFormat" label="门店是否确认" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
								<span  >{{scope.row.isShopConfirm == false?'未确认':'已确认'}}</span>
							</template>
						</el-table-column>
					<el-table-column v-if="tabs == 2" :key="8" prop="checkInfo.checkUserInfo.userName" label="审批人" show-overflow-tooltip>
						<template slot-scope="scope">
							<div v-if="scope.row.checkInfo">{{scope.row.checkInfo.checkUserInfo.userName}}</div>
						</template>
					</el-table-column>
					<el-table-column :key="12" label="审批日期" show-overflow-tooltip v-if="tabs == 2">
						<template slot-scope="scope" v-if="scope.row.checkInfo">
							<span v-if="tabs == 1"  >{{scope.row.checkInfo.checkUserInfo.operationTime}}</span>
							<span v-else >{{scope.row.checkInfo.checkUserInfo.operationTime}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="13" label="期望到货日期" show-overflow-tooltip>
						<template slot-scope="scope">						
							<span >	{{scope.row.expectTime.substring(0, 10)}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="9" prop=" procureGoodsCount" label="采购数量" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<div  >{{scope.row. procureGoodsCount}}</div>
						</template>
					</el-table-column>
					<el-table-column :key="10" prop="remarks" label="备注" show-overflow-tooltip>
						<template slot-scope="scope">
							<span  >{{scope.row.remarks == ''?'--':scope.row.remarks}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="11" label="操作" align="center" width="160">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="handleClick(scope.row,scope.$index)" v-if="tabs == 1">编辑</el-button>
							<el-button type="text" size="small" @click="handleClick(scope.row,scope.$index)" v-else>查看</el-button>
							<!-- <el-button v-if="scope.row.is_collection && tabs == 1" type="text" size="small" @click="handleCollectionClick(scope.$index,scope.row)">取消收藏</el-button>
							<el-button v-if="!scope.row.is_collection && tabs == 1" type="text" size="small" @click="handleCollectionClick(scope.$index,scope.row)">收藏</el-button> -->
							<el-button type="text" size="small" @click="handledelClick(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
			</div>
		</div>
	</div>
</template>
<script>
import {
  getProcureRequest,
  confirmProcureRequest,
} from "@/api/shopPurchaseApiNew.js";
	import {
		shenpiList,
		addcollection,
		removecollection
	} from "@/api/purchaseApi.js"
	import {
		getnocheckcount
	} from "@/api/purchaseApiNew.js"
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				tabs: 1,
				page:{
					page:1,
					pageSize:100,
					total:0
				},
				checkCount:'',  //未审批数量
				serchValue1: '', //tabs == 1搜索
				serchValue2: '', //tabs == 2搜索
				serchValue3: '', //tabs == 3搜索
				shopOptions: [{ //门店筛选
					value: '',
					label: '全部'
				}, {
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				}, {
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				},{
					value: '5e9412e0b2bfbc089daerr17',
					label: '线上旗舰店'
				}, {
					value: '5e9412e0b2bfbc089daerr10',
					label: '驯养中心'
				}, {
					value: '5e9412e0b2bfbc089daerr11',
					label: '小程序'
				}],
				isShopOptions: [{ //门店确认筛选
					value: -1,
					label: '全部'
				}, {
					value: 1,
					label: '已确认'
				}, {
					value: 2,
					label: '未确认'
				}],
				// tabs == 1
				dateValue: null, //采购申请日期
				shopValue: '', //门店筛选
				readValue: -1, //阅读筛选
				isShopConfirm: -1, //门店确认筛选
				collectionValue: -1, //收藏筛选
				// tabs == 2
				dateValue2: null, //采购申请日期
				shopValue2: '', //门店筛选
				// tabs == 3
				dateValue3: null, //采购申请日期
				dateValue4: null, //驳回日期
				shopValue3: '', //门店筛选
				tableData: [],  //商品数据
				ids:[],  //id集合生成采购单
				previousRouterTabs:'',
				selectTabs:1,
				fixedHeight:''
			}
		},
		created() {
			let that = this;
			this.fixedHeight = document.documentElement.clientHeight - 76;
			document.onkeydown = function() {
				var key = window.event.keyCode;
				if (key == 13) {
					that.getListData()
				}
			}
		},
		mounted() {
		if(sessionStorage.getItem('tabs')){
				console.log('缓存',sessionStorage.getItem('tabs'));
				this.tabs = sessionStorage.getItem('tabs')
			}
			this.resetData()
			this.getListData()
			this.getnocheckcount()
			sessionStorage.removeItem('tabs')
		},
		methods: {
			//tab切换
			handleTabClick(index) {
				this.tabs = index
				this.ids = [];
				this.getListData()
				this.resetData()
			},
			// 删除申请单
			handledelClick(row){
				console.log(row,"row");
				this.$confirm('是否删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
					id:row._id,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url4 + 'api/ProcureRequest/Delete', params).then((res) => {
					loading.close()
					if (res.code == 0) {
                     console.log(res,"res");
	                 this.$message({
						type: 'info',
						message: '已删除'
					});
					}
				})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//格式化门店确认状态
			shopConfirmFormat(row){
				if(row.shop_confirm == null){
					return '未确认'
				}else{
					return '已确认'
				}
			},
			//格式化日期
			timeFormat(time){
				let date = Number(time)*1000; 
				if (date === undefined) { 
					return ""; 
				} 
				let moment = require("moment");
				return moment(date).format("YYYY-MM-DD"); 
			},
			//格式化采购日期
			createTimeFormat(row){
				let date = Number(row.add_info.create_time)*1000; 
				if (date === undefined) { 
					return ""; 
				} 
				let moment = require("moment");
				return moment(date).format("YYYY-MM-DD"); 
			},
			//格式化驳回日期
			checkTimeFormat(row){
				console.log(row.check_info)
				if(row.check_info != null){
					let date = Number(row.check_info.check_time)*1000;
					if (date === undefined) { 
						return ""; 
					} 
					let moment = require("moment");
					return moment(date).format("YYYY-MM-DD"); 
				}else{
					return ''
				}
			},
			// 表格变化方法
			handleSelectionChange(val) {
				console.log('表格方法',val)
				let arr = [];
				for(let i = 0;i<val.length;i++){
					arr.push(val[i].procureRequestNo);
				}
				this.ids = arr;
			},
			//重置按钮
			handleResetClick(){
				this.resetData()
				this.getListData()
			},
			// 参数重置公共方法
			resetData(){
				if(this.tabs == 1){
					this.page.page = 1;
					this.page.pageSize = 10;
					this.serchValue1 = '';
					this.shopValue = '';
					this.dateValue = null;
					this.isShopConfirm = -1;
				}else if(this.tabs == 2){
					this.page.page = 1;
					this.page.pageSize = 100;
					this.serchValue2 = '';
					this.shopValue2 = '';
					this.dateValue2 = null;
					this.dateValue4 = null;
				}else if(this.tabs == 3){
					this.page.page = 1;
					this.page.pageSize = 100;
					this.serchValue3 = '';
					this.shopValue3 = '';
					this.dateValue3 = null;
					this.dateValue4 = null;
				}
			},
			//分页方法
			changePage(num){
				this.page.page = num;
				this.getListData();
			},
			//获取列表
			getListData() {
				let loading = this.$loading();
				console.log(this.dateValue,'this.dateValue')
				let parmars = null;
				let startDate = '';
				let endDate = '';
				// 未审批参数
				if(this.tabs == 1){
					if(this.dateValue != null){
						startDate = this.dateValue[0]
						endDate = this.dateValue[1]
					}else{
						startDate = ''
						endDate = ''
					}
					this.page.pageSize = 10;
					parmars = {
						pageIndex: this.page.page,  //当前页
						pageSize: this.page.pageSize,  //每页条数
						keyWord: this.serchValue1,     //关键字
						state: this.tabs,  //状态  0已删除 1未审批 2审批通过 3审批驳回 4已生成采购单
						startTime:this.$public.FTime(startDate),   //采购申请日期 开始时间
						endTime:this.$public.FTime(endDate),  //采购申请日期 结束时间
						isShopConfirm:-1,
					}
				}
				//已审批参数
				if(this.tabs == 2){
					let checkStartDate = ''
					let checkEndDate = ''
					if(this.dateValue2 != null){
						startDate = this.dateValue2[0]
						endDate = this.dateValue2[1]
					}else{
						startDate = ''
						endDate = ''
					}
					if(this.dateValue4 != null){
						checkStartDate = this.dateValue4[0]
						checkEndDate = this.dateValue4[1]
					}else{
						checkStartDate = ''
						checkEndDate = ''
					}
					this.page.pageSize = 100;
					parmars = {
						pageIndex: this.page.page,  //当前页
						pageSize: 100,  //每页条数
						isShopConfirm:-1,
						keyWord: this.serchValue2,     //关键字
						state: this.tabs,  //状态  0已删除 1未审批 2审批通过 3审批驳回 4已生成采购单
						startTime:this.$public.FTime(startDate),   //采购申请日期 开始时间
						endTime:this.$public.FTime(endDate),  //采购申请日期 结束时间
						checkStartTime:this.$public.FTime(checkStartDate),  //审批日期 开始时间
						checkEndTime:this.$public.FTime(checkEndDate)    //审批日期  结束时间
					}
				}
				// 驳回参数
				if(this.tabs == 3){
					let checkStartDate = ''
					let checkEndDate = ''
					if(this.dateValue3 != null){
						startDate = this.dateValue3[0]
						endDate = this.dateValue3[1]
					}else{
						startDate = ''
						endDate = ''
					}
					if(this.dateValue4 != null){
						checkStartDate = this.dateValue4[0]
						checkEndDate = this.dateValue4[1]
					}else{
						checkStartDate = ''
						checkEndDate = ''
					}
					this.page.pageSize = 100;
					parmars = {
						pageIndex: this.page.page,  //当前页
						pageSize: this.page.pageSize,  //每页条数
						isShopConfirm:-1,
						keyWord: this.serchValue3,     //关键字
						state: this.tabs,  //状态  0已删除 1未审批 2审批通过 3审批驳回 4已生成采购单
						startTime:this.$public.FTime(startDate),   //采购申请日期 开始时间
						endTime:this.$public.FTime(endDate),  //采购申请日期 结束时间
						checkStartTime:this.$public.FTime(checkStartDate),  //驳回日期 开始时间
						checkEndTime:this.$public.FTime(checkEndDate)    //驳回日期  结束时间
					}
				}
				// console.log(this.tabs,parmars)
				getProcureRequest(parmars).then((res)=>{
					loading.close()
					if(res.code == 0){
						// console.log(res)
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
			//所有筛选调用
			handleChange(){
				this.getListData()
			},
			//获取未审批数量
			getnocheckcount(){
				getnocheckcount().then((res)=>{
					if(res.code == 0){
						// console.log(res)
						if(res.data == 0){
							this.checkCount = ''
						}else{
							this.checkCount = res.data;
						}
					}
				})
			},
			// 编辑or查看
			handleClick(row, index) {
				console.log(row.procureRequestNo, index)
				let query = {
					procureRequestNo:row.procureRequestNo,
					tabs:this.tabs
				}
				if (this.tabs == 1) {
					this.$router.push({
						path: 'weishenpiList',
						query
					})
				} else if (this.tabs == 2) {
					let arr = [];
					query = {
						procureRequestNo:row.procureRequestNo,
						type:1
					}
					this.$router.push({
						path: 'yishenpiList',
						query
					})
				} else if (this.tabs == 3) {
					this.$router.push({
						path: 'shenpibohui',
						query
					})
				}
			},
			// 生成采购单
			handleAddOrderClick() {
				console.log(this.ids,'ids')
				if(this.ids.length == 0){
					this.$message({
						message: '请选择审批单',
						type: 'warning'
					});
					return
				}
				let query = {
					procureRequestNo:this.ids
				}
				this.$router.push({
					path: 'yishenpiList',
					query
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.warp {
		display: flex;
		flex-direction: column;
		.tabLine{
			display: flex;
			margin: 10px 0;
			.tabItem {
				width:100px;
				box-sizing: border-box;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;
				&.active {
					color: $mainColor;
				}
			}
		}
		.title {
			height: 72px;
			line-height: 72px;
			display: flex;
			background: #fff;
			align-items: center;
			border-radius: 6px;
			font-size: 14px;
			.titleInput {
				width: 140px;
			}

			.titleDate {
				width: 224px;
			}

			.titleSelect {
				width: 100px;
			}
		}

		.tabs {
			margin: 10px 0;

			.active {
				background: #F5882A;
				color: #fff;
			}

			.noactive {
				background: #fff;
				color: #000;
			}
		}

		.tableWarp {
			background: #fff;
			overflow-y: scroll;
			flex: 1;
			background: #fff;
			.is_read{
				font-weight: bold;
			}
			.readView{
				display: flex;
				align-items: center;
				.circle{
					width: 10px;
					height: 10px;
					background: red;
					border-radius: 5px;
					margin-right: 2px;
				}
			}
			
		}

		.pageSel {
			float: right;
			margin-top: 20px;
		}

		.comView {
			display: flex;
			align-items: center;
			margin-left: 10px;
		}

		.m-r-40 {
			margin-right: 40px;
		}
		
		.m-r-10 {
			margin-right: 10px;
		}
		
		.m-l-10 {
			margin-left: 10px;
		}
	}
</style>
